
import { Component, Prop, Vue } from 'vue-property-decorator'

import { EnrollmentResult } from '../types/enrollmentForm'

@Component({ name: 'EnrollmentSuccessDialog' })
export default class extends Vue {
  @Prop({ default: false }) visible!: boolean
  @Prop({ default: '' }) adminEmail!: string
  @Prop({ required: true }) result!: EnrollmentResult

  get dialogVisible(): boolean {
    return this.visible
  }

  set dialogVisible(value: boolean) {
    if (!value) this.$emit('close')
  }

  goToCustomers(): void {
    this.$emit('close')
    this.$router.push('/customers')
  }
}
